/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * Used for configuring bundles and white-listing modules
 *
 * @returns {Object.<Promise>} default - list of modules that need to be served in separate bundles
 * @param {string} [property]          - module alias (alias for route path also)
 * @param {string} webpackChunkName    - bundle name
 * @param {string} import(arg)         - path to module
 *
 */
import Dashboard from '../SelectField'
import Login from '@/components/Login'
import CreateProgram from '@/components/_modules/Programs/create'
import AdminSettings from '@/components/_modules/Admin/settings'
import ApprovalList from '@/components/_modules/Approvals/Approval-list'

export default {
  Login: {
    module: Login,
    layout: 'auth'
  },
  Programs : {
    pack   : utils.include('Programs'),
    module : () => import(/* webpackChunkName: "base"  */ './Programs'),
    layout : 'main'
  },
  Reports  : {
    module : () => import(/* webpackChunkName: "base"  */ './Reports')
  },
  Network  : () => import(/* webpackChunkName: "other" */ './Maps'),
  Dashboard: {
    module: Dashboard,
    layout: 'navless'
  },
  'Programs/create': {
    module: CreateProgram,
    layout: 'navless'
  },
  'Admin/Settings': AdminSettings,
  Admin: {
    entry: '/d/Admin/Settings'
  },
  'Admin/Approval-list': ApprovalList,

  Products: { notImplemented: true },
  Company: { notImplemented: true }
}



// WEBPACK FOOTER //
// ./src/components/_modules/bundles.pack.js